import { Steps } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { IStepper } from "./interface";

const Stepper = ({
  items,
  currentStep,
  status,
  onChange,
  direction = "vertical",
  size = "default",
  highestStepReached,
}: IStepper) => {
  // Add checkmark icons to completed steps (steps before the highest step reached)
  const itemsWithIcons = items.map((item, index) => {
    const maxStep = highestStepReached ?? currentStep;
    if (index < maxStep) {
      return {
        ...item,
        icon: (
          <CheckCircleFilled style={{ color: "#52c41a", fontSize: "32px" }} />
        ),
      };
    }
    return item;
  });

  return (
    <Steps
      current={currentStep}
      onChange={onChange}
      status={status}
      direction={direction}
      items={itemsWithIcons}
      responsive={false}
      size={size}
    />
  );
};

export default Stepper;
